export default function JobSearchBanner() {
  return (
    <div className="p-6 bg-gradient-to-r from-emerald-600/20 to-green-700/20 border border-emerald-400/30 rounded-lg mb-6">
      <h4 className="text-emerald-200 font-semibold mb-2 text-center">
        Seeking Full-Time Opportunities
      </h4>
      <p className="text-gray-300/80 text-sm text-center">
        I'm actively looking for a full-time position where I can contribute to meaningful projects
        while continuing to develop my skills in web development and technology.
      </p>
    </div>
  );
}